<mat-form-field>
  <mat-label>{{'registration.co2.maintenance_system' | translate}}</mat-label>
  <mat-date-range-input (click)="picker.open()"
                        [formGroup]="form.controls['maintenanceWindow'+index]"
                        [rangePicker]="picker">
    <input matStartDate  placeholder="Startdatum" formControlName="start">
    <input matEndDate placeholder="Enddatum" formControlName="end">
  </mat-date-range-input>
  <mat-hint *ngIf="lastIndex === index">{{ 'registration.co2.maintenance_system_info' | translate }}</mat-hint>
  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-date-range-picker #picker
                         startView="month"
  ></mat-date-range-picker>
</mat-form-field>
